import { drupalComponent } from '@nech/src/helpers/drupal-component';
import { trapFocus, TrapFocusCleanup } from '@nech/src/helpers/function-helpers';

(function (Drupal, once, $) {
  const isMobileTablet = window.innerWidth < 1024;

  drupalComponent('header', {
    selector: '#navigation',
    shared: {
      closeNavMenu: function (
        event: { target: any; stopPropagation: () => void },
        modalSearchEl: JQuery<HTMLElement>,
        globalSearchEl: JQuery<HTMLElement>,
        ignoreTargeting?: boolean,
      ) {
        if (
          (ignoreTargeting || !$(event.target).closest('.nech-navigation-menu').length) &&
          !$(event.target).is('.nech-nav__button') &&
          !$(event.target).closest(modalSearchEl.find('.nech-global-searchfield')).length &&
          !$(event.target).closest(modalSearchEl.find('.modal-search--dropdown')).length &&
          !$(event.target).closest(modalSearchEl.find('.modal-search--quick-access')).length &&
          !$(event.target).closest(globalSearchEl).length
        ) {
          event.stopPropagation();
          $('.navigation-menu').each((idx, el) => {
            const $submenu = $(el);
            const $menuItem = $(el).closest('.menu-item');
            $menuItem.find('button.nech-nav__button').attr('aria-expanded', 'false');
            setTimeout(() => {
              $('html').css('overflow', 'auto');
              $submenu.find('.nech-navigation-menu').addClass('-translate-x-full');
            }, 100);
          });

          setTimeout(() => {
            $('.navigation-menu').hide();
          }, 300);

          $('.nech-navigation-menu').removeClass('lg:max-w-[400px]').addClass('lg:max-w-[440px]');

          $('.nech-navigation-menu').addClass('-translate-x-full');

          $('.nech-navigation-menu .second-level-label').attr('aria-hidden', 'true');
          $('.nech-navigation-menu .top-menu-nav-2').find('a').attr('aria-hidden', 'true');
          $('.nech-navigation-menu .second-level-label').attr('tabindex', '-1');
          $('.nech-navigation-menu .top-menu-nav-2').attr('tabindex', '-1');
          $('.nech-navigation-menu .top-menu-nav-2').find('a').attr('tabindex', '-1');

          $('.nech-navigation-menu .third-level-label').attr('aria-hidden', 'true');
          $('.nech-navigation-menu .top-menu-nav-3').find('a').attr('aria-hidden', 'true');
          $('.nech-navigation-menu .third-level-label').attr('tabindex', '-1');
          $('.nech-navigation-menu .top-menu-nav-3').find('a').attr('tabindex', '-1');

          $('.nech-navigation-menu .fourth-level-label').attr('aria-hidden', 'true');
          $('.nech-navigation-menu .fourth-level-label').attr('tabindex', '-1');

          $('.menu-level-4').each(function () {
            if (!$(this).hasClass('opacity-0')) {
              $(this).addClass('opacity-0 h-0');
            }
          });
          $('.third-level-label').css('font-weight', '400');

          $('.top-menu-nav-3').css('min-height', '150px');
          $('.top-menu-nav-2').css('min-height', '150px');
          $('.third-level-label').removeClass('paragraph-m-bold').addClass('paragraph-m');

          $('.nav-menu--top-nav-level-1').removeClass('hidden');

          $('.nav-menu--icon-show-links-last-level')
            .removeClass('text-primary-700')
            .addClass('text-neutral-300');

          $('.nav-menu--arrow-icon-second-level')
            .removeClass('text-primary-700')
            .addClass('text-neutral-300');

          $('.nav-menu--icon-show-links-last-level').css('transform', 'rotate(0deg)');
          $('.top-menu-nav-2').find('.top-menu-nav-2-content').find('span').removeClass();

          $('.first-level-label').removeClass('hidden').addClass('block');

          $('.menu-level-3, .menu-level-2')
            .addClass('-translate-x-full')
            .removeClass('translate-x-0 absolute')
            .addClass('fixed');
          setTimeout(() => {
            $('.menu-level-3, .menu-level-2').css({
              left: '0',
              top: '0',
            });
          }, 0);

          $('.top-menu-nav-2').removeClass('block').addClass('hidden');

          $('.menu-level-2').removeClass('lg:w-1/2').addClass('w-full');

          $('.menu-level-2, .menu-level-3').removeClass('ease-in-out transition-all duration-500');

          $('.menu-level-4').each(function () {
            if (!$(this).hasClass('opacity-0')) {
              $(this).addClass('opacity-0 h-auto hidden');
            }
          });
        }
      },

      displayModal: function (
        $globalSearchEl: JQuery<HTMLElement>,
        $modalSearchEl: JQuery<HTMLElement>,
      ) {
        $globalSearchEl.addClass('hidden');
        $globalSearchEl.trigger('blur');
        $modalSearchEl.removeClass('hidden');
        $modalSearchEl.removeAttr('aria-hidden');
        setTimeout(() => {
          $('html').css('overflow', 'hidden');
        }, 0);
      },

      hideModal: function (
        $globalSearchEl: JQuery<HTMLElement>,
        $modalSearchEl: JQuery<HTMLElement>,
        $modalDropdownEl: JQuery<HTMLElement>,
      ) {
        $globalSearchEl.removeClass('hidden');
        $modalSearchEl.addClass('hidden');
        $modalSearchEl.attr('aria-hidden', 'true');
        $modalDropdownEl.attr('aria-hidden', 'true');
        $modalDropdownEl.removeClass('opacity-1').addClass('opacity-0');
        $modalDropdownEl.addClass('-translate-y-full');
      },
    },
    instance() {
      const self = this;
      const $el = $(this.selector);
      const $nav = $('#navigation');
      const $menu = $('#menu-mobile');
      const $listItems = $('.header--list-items');
      const $secondaryMenu = $('#secondary-menu-mobile');
      const $secondaryMenuDesktop = $el.find('#secondary-menu');
      const $navContent = $('#nav-bottom-content');
      const $openButton = $nav.find('.burger-icon');
      const $closeButton = $nav.find('.header--close-button.ph-x');
      const $globalSearch = $el.find('.header-global-search').children();
      const $modalSearch = $el.find('.header-modal-search');
      const $searchInput = $modalSearch.find('input[name="global-search"]');
      const $modalDropdown = $modalSearch.find('.modal-search--dropdown');

      let searchModalTrapCleanup: TrapFocusCleanup | null = null;

      const openSearchModal = () => {
        self.shared.displayModal($globalSearch, $modalSearch);
        searchModalTrapCleanup = trapFocus({
          el: $modalSearch,
          forceAutofocusEl: $searchInput
        });
      };

      const closeSearchModal = () => {
        if (searchModalTrapCleanup) {
          searchModalTrapCleanup();
          searchModalTrapCleanup = null;
        }
        self.shared.hideModal($globalSearch, $modalSearch, $modalDropdown);
        $('html').css('overflow', '');
        $searchInput.val('');
        $globalSearch.first().trigger('focus');
      };

      //toggle modal search
      $globalSearch.on('click keypress', function (event) {
        event.stopPropagation();
        openSearchModal();
      });

      $(document).on('click', function (event) {
        // SUA1616-582 : ce handler rejouait une dizaine de selecteurs et
        // remettait le focus sur la barre de recherche a chaque clic n'importe
        // ou dans la page. Il n'a rien a faire tant que la modale est fermee.
        if ($modalSearch.hasClass('hidden')) {
          return;
        }
        if (
          !$(event.target).closest($modalSearch.find('.nech-global-searchfield')).length &&
          !$(event.target).closest($modalSearch.find('.modal-search--dropdown')).length &&
          !$(event.target).closest($modalSearch.find('.modal-search--quick-access')).length &&
          !$(event.target).closest($globalSearch).length
        ) {
          closeSearchModal();
        } else {
          setTimeout(() => {
            $('html').css('overflow', 'hidden');
          }, 100);
        }
      });

      $(document).on('keyup', function (e) {
        if (e.key === 'Escape' && !$modalSearch.hasClass('hidden')) {
          closeSearchModal();
        }
      });

      $modalSearch.find('.modal-search--close-icon-button').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeSearchModal();
      });

      // SUA1616-582 : le handler de fermeture sur document rejouait une
      // quarantaine de selecteurs globaux et reecrivait attributs et styles sur
      // plus de 500 noeuds a chaque clic n'importe ou dans la page. On le
      // conditionne a un sous-menu reellement ouvert.
      let isSubmenuOpen = false;

      //close navigation menu with icon close
      $(document).on('click', '.nech-navigation-menu .nav-menu--close-button', function (event) {
        if (submenuTrapCleanup) {
          submenuTrapCleanup();
          submenuTrapCleanup = null;
        }
        $(document).trigger('nech:nav-closed');
        // Le bouton de fermeture est a l'interieur de .nech-navigation-menu, donc
        // le handler sur document ne remettait pas les niveaux 2 a 4 a zero : la
        // remise a zero n'arrivait qu'au clic suivant. On la fait ici.
        self.shared.closeNavMenu(event, $modalSearch, $globalSearch, true);
        isSubmenuOpen = false;
        $('.navigation-menu').each((idx, el) => {
          const $submenu = $(el);
          const $menuItem = $(el).closest('.menu-item');
          $menuItem.find('button.nech-nav__button').attr('aria-expanded', 'false');
          setTimeout(() => {
            $('html').css('overflow', 'auto');
            $submenu.find('.nech-navigation-menu').addClass('-translate-x-full');
          }, 100);
        });
        setTimeout(() => {
          $('.navigation-menu').hide();
        }, 300);

        closeMenu();
      });

      let submenuTrapCleanup: TrapFocusCleanup | null = null;

      //open navigation menu
      $('.navigation-menu').each((idx, el) => {
        const $submenu = $(el);
        const $menuItem = $(el).closest('.menu-item').find('button.nech-nav__button');
        $menuItem.on('click', () => {
          if (submenuTrapCleanup) {
            submenuTrapCleanup();
            submenuTrapCleanup = null;
          }
          $menuItem.attr('aria-expanded', 'true');
          isSubmenuOpen = true;
          $submenu.show();
          setTimeout(() => {
            $('html').css('overflow', 'hidden');
            $submenu.find('.nech-navigation-menu').removeClass('-translate-x-full');
            submenuTrapCleanup = trapFocus({
              el: $submenu.find('.nech-navigation-menu'),
            });
          }, 0);
        });
      });

      //close navigation menu
      $(document).on('click', function (event) {
        if (!isSubmenuOpen) {
          return;
        }
        self.shared.closeNavMenu(event, $modalSearch, $globalSearch);
        if (submenuTrapCleanup) {
          submenuTrapCleanup();
          submenuTrapCleanup = null;
        }
        $(document).trigger('nech:nav-closed');
        isSubmenuOpen = false;
      });

      $(document).on('keyup', function (event) {
        $el.find('.navigation-menu').each(function(){
          if ($(this).length && $(this).is(':visible') && event.key === 'Escape') {
            if (submenuTrapCleanup) {
              submenuTrapCleanup();
              submenuTrapCleanup = null;
            }
            $(document).trigger('nech:nav-closed');
            self.shared.closeNavMenu(event, $modalSearch, $globalSearch, true);
            isSubmenuOpen = false;
            closeMenu();
            $('.nech-nav__button').trigger('focus')
          }
        })
      });

      $menu.hide();
      $secondaryMenu.hide();
      $closeButton.hide();

      let navMenuTrapCleanup: TrapFocusCleanup | null = null;

      const openMenu = () => {
        $menu.fadeIn();
        $secondaryMenu.fadeIn();
        $openButton.hide();
        $closeButton.show();
        $nav.addClass('nav--open');
        $listItems.removeClass('hidden');
        $openButton.attr('aria-hidden', 'true');
        $closeButton.attr('aria-hidden', 'false');
        setTimeout(() => {
          navMenuTrapCleanup = trapFocus({
            el: $el,
            forceAutofocusEl: $closeButton,
          });
        }, 0);
      };

      const closeMenu = () => {
        if (navMenuTrapCleanup) {
          navMenuTrapCleanup();
          navMenuTrapCleanup = null;
        }
        $menu.hide();
        $secondaryMenu.hide();
        $openButton.show();
        $closeButton.hide();
        $nav.removeClass('nav--open');
        $listItems.addClass('hidden');
        $openButton.attr('aria-hidden', 'false');
        $closeButton.attr('aria-hidden', 'true');
        $('html').css('overflow', '');
      };

      //close menu with escape button
      $(document).on('keyup', function (event) {
        if ($closeButton.length && $closeButton.attr('aria-hidden') !== 'true' && event.key === 'Escape') {
          closeMenu();
      }
    });

      $openButton.on('click', openMenu);
      $closeButton.on('click', closeMenu);

      $openButton.on('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openMenu();
        }
      });

      $closeButton.on('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          closeMenu();
        }
      });

      let lastScrollTop = 0;
      let scrollFrame: number | null = null;

      // SUA1616-582 : le handler lisait scrollTop() puis ecrivait des classes a
      // chaque evenement scroll. On le ramene a une passe par frame.
      const handleScroll = () => {
        const scrollTop = $(window).scrollTop() as number;

        if (scrollTop > lastScrollTop && !$nav.hasClass('nav--open')) {
          $nav.addClass('nav-hidden').removeClass('sticky');
        } else if (scrollTop < lastScrollTop && scrollTop !== 0) {
          $nav.addClass('sticky').removeClass('nav-hidden');
          $navContent.removeClass('lg:py-7').css('transition', '').addClass('lg:py-3');
        } else if (scrollTop <= 200) {
          $nav.removeClass('nav-hidden sticky');
          $navContent.addClass('lg:py-7').css('transition', 'ease 300ms');
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      };

      $(window).on('scroll', function () {
        if (scrollFrame !== null) {
          return;
        }
        scrollFrame = requestAnimationFrame(() => {
          scrollFrame = null;
          handleScroll();
        });
      });

      /*manage aria hidden*/
      if (isMobileTablet) {
        $secondaryMenuDesktop.attr('aria-hidden', 'true');
        $secondaryMenu.attr('aria-hidden', 'false');
        $closeButton.attr('aria-hidden', 'false');
        $openButton.attr('aria-hidden', 'true');
      } else {
        $secondaryMenuDesktop.attr('aria-hidden', 'false');
        $secondaryMenu.attr('aria-hidden', 'true');
        $closeButton.attr('aria-hidden', 'true');
        $openButton.attr('aria-hidden', 'false');
      }

      //set attr unique id for navigation menu
      $el.find('.menu-item').each(function (index) {
        var uniqueId = 'nech-navigation-menu-' + index;
        $(this).find('.navigation-menu').attr('id', uniqueId);
        $(this).find('[aria-controls="nech-navigation-menu"]').attr('aria-controls', uniqueId);
      });
    },
  });
})(Drupal, once, jQuery);
